<template>
  <div class="root_card">
    <div class="card">
      <!--封面-->
      <div
        class="bgpic"
        :style="{
          background:
            'url(' +
            $handleAssetsUrl(template.thumbnailUrl) +
            ') center/cover no-repeat',
        }"
      >
        <!--静态-->
        <div class="static">
          <div class="rt-panel">
            <!-- <div
              v-if="transTempPayType(template) == 3"
              class="vipfree"
            ></div> -->
            <div class="business" v-if="template.isCommercial || template.isCommerical"></div>
          </div>
          <span class="duration">{{ template.duration | secToMin }}</span>
          <!--vip角标 所有用户均显示-->
          <div class="rb-panel">
            <div
              v-if="template.payType == 1 || template.payType === 4 || template.payType == 6"
              :class="template.payType == 6 ? getBadgeClassName(6, 'compvip') : getBadgeClassName(4, IsOldUser ? 'vip' : 'enterpriseS')"
            ></div>
          </div>
        </div>

        <!--悬浮-->
        <div
          class="hover"
          @mouseenter.self="playVideo"
          @click.prevent.stop="useTemp"
          @mouseleave.self="stopVideo"
        >
          <video muted="true" class="video" ref="myvideo"></video>
          <el-button
            type="primary"
            size="mini"
            round
            class="use-rightnow"
            @click.prevent.stop="useTemp"
            >立即使用</el-button
          >
          <div class="rt-panel">
            <div class="preview" @click.prevent.stop="previewClick">
              <span class="preview-svg"></span>
              <span>预览</span>
            </div>
            <div class="collect">
              <div
                :class="template.f ? 'like' : 'dislike'"
                @click.prevent.stop="favoriteClick"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!--名称价格-->
      <div class="title-price">
        <div class="temp-des">
          <span class="des-title">{{ template.title }}</span>
        </div>
        <div class="temp-info">
          <div class="info-price">
            <!-- <span v-if="transTempPayType(template) == 0" class="pay-type">免费</span> -->
            <span v-if="transTempPayType(template) == 1 " class="pay-type price"
              >￥{{ template.price }}元</span
            >
            <span v-if="transTempPayType(template) == 2" class="pay-type"
              >已购买</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import transTempTypeMixin from "../../../../mixins/trans-temp-type";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  mixins: [transTempTypeMixin, vipBadge],
  props: {
    template: {
      type: Object,
      required: true,
      default: () => {},
    },
    direction: {
      type: String,
      default: "1", //1横2竖
    },
  },
  data() {
    return {
      videoUrl: "",
      coverUrl: this.$handleAssetsUrl(this.template.thumbnailUrl),
    };
  },
  methods: {
    playVideo() {
      try {
        let url = this.$handleAssetsUrl(this.template.videoUrl).replace(
          ".mp4",
          "nail.mp4"
        );
        if (!this.$refs["myvideo"].src !== url) this.$refs["myvideo"].src = url;
        //console.log(this.$refs['myvideo'])
        setTimeout(() => {
          this.$refs["myvideo"].play();
        }, 300);
      } catch (error) {}
    },
    stopVideo() {
      try {
        this.$refs["myvideo"].pause();
        this.$refs["myvideo"].currentTime = 0;
      } catch (error) {}
    },
    previewClick() {
      this.$emit("previewClick", this.template);
    },
    useTemp() {
      let type = this.transTempPayType(this.template);
      if (type == 1) {
        this.$emit("previewClick", this.template);
      } else {
        this.$bus.$emit("templib-tempuse-isopen", this.template);
        this.trackSearchResultClick(this.template);
      }
    },
    trackSearchResultClick(item = {}) {
      if (!this.$parent.keyword) {
        return;
      }
      sensors.track("searchResultClick", {
        choose_price: this.trackingData.choose_price,
        click_type: "添加到画布",
        keyword_type: this.trackingData.keyword_type,
        keyword: this.trackingData.keyword,
        order_method: this.trackingData.order_method,
        position_number: "",
        search_source: "编辑器素材弹窗",
        template_id: this.$route.template || "",
        template_name: "",
        template_style: "",
        template_type: "",
        material_id: item.id || "",
        // material_name: item.title || "",
      });
    },
    favoriteClick() {
      const API = this.template.f
        ? "/api/user/template/cancelFavorites"
        : "/api/user/template/favorites";
      let item = this.template;
      sensors.track("collectContent", {
        author_id: this.UserMsg.id,
        author_name: this.UserMsg.nickname,
        business: "",
        collect_content: "场景",
        content_duration: this.TOOL.getDuration() / 1000,
        content_id: this.WorksId,
        content_name: this.WorksName,
        material_id: item.id,
        // material_name: item.title,
        module: "编辑器素材弹窗",
        operation_type: this.template.f ? "取消收藏" : "收藏",
        price_type: ((payType) => {
          if (payType == 0) {
            return "免费";
          }
          if (payType == 1) {
            return "付费";
          }
          if (payType == 4) {
            return "会员免费";
          }
          return "全部价格";
        })(item.payType),
        price: item.price - 0,
        purpose: "",
        template_id: this.$route.template || "",
        template_name: "",
        template_style: "",
        template_type: "",
      });
      this.$http
        .post(API, {
          id: this.template.id,
        })
        .then(({ data }) => {
          if (data.code !== 200) return;
          this.showLikesToast(this.template.f ? 'unlikes' : 'likes');
          this.template.f = !this.template.f;
        });
    },
    showLikesToast (type = 'likes') {
      if (type === 'likes') {
        this.$message({
          message: "收藏成功",
          type: "success",
        });
      }
      if (type === 'unlikes') {
        this.$message('收藏已取消');
      }
    }
  },
  computed: {
    ...mapGetters(["isRealVip", "UserMsg", "TOOL", "WorksId", "WorksName", 'IsOldUser']),
    ...mapGetters({
      trackingData: "tracking/trackingData",
    }),
  },
  filters: {
    secToMin(duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      //duration = parseFloat(duration / 1000);
      var min = Math.floor(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
  },
};
</script>

<style lang="scss" scoped>
.root_card {
  .card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 4px;
    //overflow: hidden;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0);
    transition: all 0.2s linear;
    position: relative;
    &:hover {
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0);
      transform: scale(1.1);
      .bgpic {
        border-radius: 5px;
        .static {
          opacity: 0;
        }
        .hover {
          border-radius: 5px;
          opacity: 1;
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        }
      }
      .title-price {
        opacity: 0;
        //height: 0px;
      }
    }
    .bgpic {
      flex: 1;
      position: relative;
      border-radius: 5px;
      .static {
        position: absolute;
        width: 100%;
        height: 100%;
        transition: all 0.15s linear;
        .duration {
          font-size: 12px;
          width: 40px;
          line-height: 14px;
          height: 14px;
          background: rgba(1, 1, 1, 0.4);
          color: #fff;
          position: absolute;
          left: 6px;
          bottom: 6px;
          border-radius: 7px;
        }
        .rt-panel {
          position: absolute;
          right: 3px;
          top: 3px;
          width: 100%;
          height: 24px;
          .vipfree {
            float: right; //为子元素设定布局流向
            width: 64px;
            height: 24px;
            background-image: url(../../../../../../static/svg/template-material-lib/common/vipfree.svg);
          }
          .business {
            margin: 0 4px 0 0;
            float: right;
            width: 20px;
            height: 24px;
            background-image: url(../../../../../../static/svg/template-material-lib/common/business.svg);
          }
        }
        .rb-panel {
          position: absolute;
          right: 3px;
          bottom: 3px;
          height: 17px;
          .vip {
            float: right;
            width: 36px;
            height: 16px;
            background-image: url(../../../../../../static/svg/payTypeSubscript/vip36x16.svg);
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .compvip {
            float: right;
            width: 50px;
            height: 16px;
            background-image: url(../../../../../../static/svg/payTypeSubscript/companyVip50x16.svg);
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .enterpriseS {
            float: right;
            width: 50px;
            height: 16px;
            // background-image: url(../../../../../../static/svg/payTypeSubscript/enterpriseS.png);
            background-image: url(../../../../../../static/svg/payTypeSubscript/enterpriseSVIP.svg);
            background-size: 100%;
            background-repeat: no-repeat;
          }
          .pro {
            width: 30px;
            height: 18px;
            content: url(../../../../../assets/pro.png);
          }
          .proPlus {
            width: 32px;
            height: 18px;
            content: url(../../../../../assets/proPlus.png);
          }
        }
      }
      .hover {
        width: 100%;
        height: 100%;
        font-size: 12px;
        position: absolute;
        transition: all 0.2s linear;
        opacity: 0;
        .video {
          border-radius: 4px;
          width: 100%;
          height: 100%;
          background: transparent;
        }
        .use-rightnow {
          position: absolute;
          font-size: 12px;
          left: 4px;
          bottom: 4px;
          width: 88px;
          height: 28px;
        }
        .rt-panel {
          top: 4px;
          right: 4px;
          width: 100%;
          height: 20px;
          position: absolute;
          .collect {
            float: right; //为子元素设定值
            width: 24px;
            height: 100%;
            background-color: #ffffffaa;
            border-radius: 6px;
            padding: 4px 0 0 6px;
            margin: 0 4px 0 0;
            .like {
              height: 12px;
              width: 12px;
              background-image: url(../../../../../../static/svg/template-material-lib/common/like.svg);
            }
            .dislike {
              height: 12px;
              width: 12px;
              background-image: url(../../../../../../static/svg/template-material-lib/common/dislike.svg);
            }
            &:hover {
              background-color: #ffffff;
            }
          }
          .preview {
            width: 56px;
            height: 20px;
            line-height: 20px;
            background-color: #ffffffaa;
            border-radius: 6px;
            float: right;
            height: 100%;
            color: #474261;
            .preview-svg {
              float: left;
              width: 16px;
              height: 12px;
              margin: 4px 0 0 4px;
              background-image: url(../../../../../../static/svg/template-material-lib/common/preview.svg);
            }
            &:hover {
              background-color: #ffffff;
            }
          }
        }
      }
    }
    .title-price {
      width: 100%;
      height: 24px;
      overflow: hidden;
      transition: all 0.15s linear;
      .temp-des {
        width: 100px;
        height: 100%;
        float: left;
        overflow: hidden;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: center;
        position: relative;
        //border-bottom: 1px solid #f0eff5;
        .des-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #333;
          letter-spacing: 1px;
          font-size: 12px;
          text-align: left;
          padding-top: 0px;
        }
      }
      .temp-info {
        color: #ff3a3f;
        height: 30px;
        float: right;
        display: flex;
        font-size: 12px;
        overflow: hidden;
        align-items: center;
        justify-content: space-between;
        .info-price {
          margin: 0 10px 0 0;
          height: 100%;
          display: flex;
          align-items: center;
          .pay-type {
            height: 100%;
            align-items: center;
            display: flex;
            color: #ff3a3f;
            &.price {
              color: #ff3a3f;
            }
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/emodal/templateLib/contents/template/templateItem.vue